import SingleBallotModalContainer from './SingleBallotModalContainer';

export default SingleBallotModalContainer;
